import * as MemoryCache from 'memory-cache';
import { initializeTokenProvider, getAccessTokenforResource } from './getAccessTokenforResource';

export default function registerTokenProvider(windowObject: Window) {
    initializeTokenProvider(new MemoryCache.Cache());
    getAccessTokenforResource(windowObject.location.origin);
}
